import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
    const [faqs, setFaqs] = useState([]);
    useEffect(() => { api.get("/faq").then(({ data }) => setFaqs(data.faqs)); }, []);

    const categories = [...new Set(faqs.map((f) => f.category))];

    return (
        <div className="mx-auto max-w-3xl px-5 py-14">
            <p className="eyebrow mb-3 text-center">Support</p>
            <h1 className="font-serif text-4xl md:text-5xl tracking-tight mb-12 text-center">Frequently Asked Questions</h1>
            {categories.map((cat) => (
                <div key={cat} className="mb-8">
                    <h2 className="text-sm uppercase tracking-[0.18em] text-gold mb-3">{cat}</h2>
                    <Accordion type="single" collapsible className="border-t border-[#E8DFD5]">
                        {faqs.filter((f) => f.category === cat).map((f) => (
                            <AccordionItem key={f.id} value={f.id} className="border-b border-[#E8DFD5]">
                                <AccordionTrigger data-testid={`faq-${f.id}`} className="text-left hover:no-underline hover:text-gold py-4">{f.question}</AccordionTrigger>
                                <AccordionContent className="text-muted-foreground leading-relaxed">{f.answer}</AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            ))}
        </div>
    );
}
